import React, { createContext, FC, useContext } from 'react'
import { useMembership } from '../hooks/useMembership'

interface IMembershipContextState extends ReturnType<typeof useMembership> {}

export const MembershipContext = createContext<IMembershipContextState>(
  {} as IMembershipContextState
)

/**
 * Gives access to multiple membership-related APIs and methods
 */
export const MembershipProvider: FC = ({ children }) => {
  const state = useMembership()
  return <MembershipContext.Provider value={state}>{children}</MembershipContext.Provider>
}

export const useMembershipContext = () => useContext(MembershipContext)
